import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { format } from "date-fns";
import way2news from "../../assets/images/Way2news-logo.png";
import API from "../../services/api";

function ProposalPdf (props){

  const [mobile, setMobile] = useState()

  const getMobile = async() =>{
    try {
      let res = await API({
        url:'/saleslocation/mobile',
        method:'POST',
        responseType:'json',
        data:{}
      })
      if(res.code === 200){
        setMobile(res.data)
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(()=>{
    getMobile()
  },[])

  const downloadRef = React.useRef();

  // Styles for the document
  Font.register({
    family: "Supermercado One",
    src: "https://raw.githubusercontent.com/google/fonts/main/ofl/supermercadoone/SupermercadoOne-Regular.ttf",
  });
  
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "#fff",
      padding: 60,
      fontFamily: "Times-Roman",
      fontSize: 12,
      lineHeight: 1.5,
    },
    watermark: {
      position: "absolute",
      top: "50%",
      right: -140,
      transform: "translateY(-50%) rotate(270deg)",
      fontSize: 80,
      color: "rgba(0, 0, 0, 0.1)",
      fontFamily: "Supermercado One",
      letterSpacing: 2,
      opacity: 0.05,
      zIndex: -1,
    },
    header: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginLeft: "auto",
      marginBottom: 20,
    },
    logo: {
      width: "50px",
      height: "50px",
    },
    section: {
      marginBottom: 30,
    },
    noteText: {
      fontWeight: "bold",
      marginBottom: 10,
    },
    container: {
      marginRight: 20,
    },
    textJustify: {
      textAlign: "justify",
    },
    table: {
      display: "table",
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#000",
      marginTop: 10,
    },
    tableHeader: {
      flexDirection: "row",
      backgroundColor: "#f5c189",
      fontWeight: "bold",
    },
    tableRow: {
      flexDirection: "row",
      borderBottom: "1px solid #000",
    },
    tableCell: {
      padding: 5,
      borderRight: "1px solid #000",
      textAlign: "center",
      fontSize: 10,
      flexGrow: 1, // Allow flexible column width
    },
    col1: {
      flexBasis: "25%", // Adjust column width
    },
    col2: {
      flexBasis: "20%",
    },
    col3: {
      flexBasis: "15% !important",
    },
    col4: {
      flexBasis: "20%",
    },
    col5: {
      flexBasis: "20%",
    },
    marginTop:{
      marginTop:10
    }
  });


  const MyDocument = () => (
    <Document title={props.company} author="Way2news" subject="Proposal" keywords="proposal">
      <Page size="A4" style={styles.page}>
      <Text style={styles.watermark}><Image src={way2news} alt="logo" style={styles.logo} />way2news</Text>
      <View style={styles.container}>
        <View style={styles.header}>
          <Image src={way2news} alt="logo" style={styles.logo} />
          <View>
            <Text style={styles.marginTop}>{`${format(
              new Date(),
              "dd, MMM, yyyy"
            )},`}</Text>
            <Text >{props.location}</Text>
          </View>
        </View>
        <View style={styles.section}>
          <Text >To,</Text>
          <Text style={styles.brandNameText}>{props.company}</Text>
          {props.address && (
            <Text >{props.address}</Text>
          )}
        </View>
        <View style={styles.section}>
          <Text style={styles.toText}>Respected Sir,</Text>
        </View>

        <View style={styles.section}>
          <Text>
            Subject:Speical rates exclusively for {`${props.company}`}
          </Text>
        </View>

        <View style={[styles.section, styles.textJustify]}>
          <Text>
            Way2News is No. 1. India's vernacular short News Platform is present
            in 8 different languages across India clocking 7 crore+ downloads.
            With more than 60+lakh people reading our news from Telugu states
            every single day, we are the unbeatable leader in AP & TS regions.
          </Text>
        </View>

        <View style={[styles.section, styles.textJustify]}>
          <Text>
            With people consuming news on our app from each & every corner of
            the state covering all taluks, villages, mandals, and districts, we
            are the new daily in people’s hands to read news. Below are the
            special rates that were crafted especially for you by taking
            insights and inputs from our earlier meetings.
          </Text>
        </View>

        <View style={[styles.section, styles.textJustify]}>
          <Text>
            Attached are the special rates only for {`${props.company}`} as per your inputs.
            We request you to kindly consider Way2News in your monthly media
            plan & get great visibility for your {`${props.brand_name}`}. We also assure you of
            the best of the services at all times.
          </Text>
        </View>
        <View style={styles.section}>
            <Text>{props.name}</Text>
            <Text>Assistant Manager</Text>
            <Text>Way2News Pvt Ltd,</Text>
            <Text>Ph:{`${mobile}`}</Text>

        </View>
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
      <Text style={styles.watermark}><Image src={way2news} alt="logo" style={styles.logo} />way2news</Text>
          
      <View style={styles.header}>
          <Image src={way2news} alt="logo" style={styles.logo} />
          
        </View>
        <View style={styles.section}>
            <Text style={styles.noteText}>Note:</Text>
            <Text>All the quotes are valid only for 45 Days from the date of the proposed date & 18% GST as applicable. </Text>
            </View>
        <View style={styles.section}>
            <Text>Following are the campaign details please review below:</Text>
        </View>
        <View style={styles.table}>
            {/* Table Header */}
            <View style={styles.tableHeader}>
            <Text style={[styles.tableCell, styles.col1]}>Location</Text>
              <Text style={[styles.tableCell, styles.col2]}>Inventory Type</Text>
              <Text style={[styles.tableCell, styles.col3]}>Page Position</Text>
              <Text style={[styles.tableCell, styles.col4]}>Actual Cost Per Day</Text>
              <Text style={[styles.tableCell, styles.col5]}>Offer Cost Per Day</Text>
            </View>

            {/* Table Body */}
            {(props.selected).map((item, index) => {
              // Check if the price is 0 and skip rendering the row if it is
              if (props?.price[item] === 0) {
                return null;
              }

              return (
                <View style={styles.tableRow} key={index}>
                  <Text style={[styles.tableCell, styles.col1]}>
                    {props.generateLocationString(props.price, "pdf")}
                  </Text>
                  <Text style={[styles.tableCell, styles.col2]}>{props.adType}</Text>
                  <Text style={[styles.tableCell, styles.col3]}>{item}</Text>
                  <Text style={[styles.tableCell, styles.col4]}>
                    {props.price.priceObj[item]}
                  </Text>
                  <Text style={[styles.tableCell, styles.col5]}>
                    {props.discounts[item]?.discountedPrice || props.price.priceObj[item]}
                  </Text>
                </View>
              );
            })}
          </View>
        </Page>
    </Document>
  );

  return (
    <>
    <PDFDownloadLink document={<MyDocument />} fileName="proposal.pdf" className="mb-3">
      Download Proposal
    </PDFDownloadLink>
    <PDFViewer
      style={{ width: "100%", height: "800px", border: "1px solid black" }}
    >
      <MyDocument />
    </PDFViewer></>
  );
}

export default ProposalPdf;
